import { BILLING } from "@/lib/data";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#1A1A1A] text-[#F7F5F0] py-14 md:py-16"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-12 gap-6">
                <div className="col-span-12 md:col-span-6">
                    <h3 className="font-serif-display text-3xl md:text-4xl leading-tight">
                        {BILLING.name}
                    </h3>
                    <p className="eyebrow !text-[#C67C4E] mt-3">
                        {BILLING.tagline} · {BILLING.union}
                    </p>
                </div>
                <div className="col-span-12 md:col-span-6 flex flex-col md:items-end gap-3 justify-end">
                    <a
                        href={`mailto:${BILLING.email}`}
                        className="text-sm text-[#F7F5F0]/80 link-underline"
                    >
                        {BILLING.email}
                    </a>
                    <a
                        href={`tel:${BILLING.phone.replace(/\D/g, "")}`}
                        className="text-sm text-[#F7F5F0]/80 link-underline"
                    >
                        {BILLING.phone}
                    </a>
                </div>
                <div className="col-span-12 mt-10 pt-6 border-t border-[#F7F5F0]/10 flex flex-col md:flex-row md:items-center justify-between gap-3">
                    <p className="text-xs text-[#F7F5F0]/40 tracking-wider">
                        © {year} {BILLING.name}. All rights reserved.
                    </p>
                    <a
                        href="/admin"
                        data-testid="admin-footer-link"
                        className="text-[10px] tracking-[0.3em] uppercase text-[#F7F5F0]/30 hover:text-[#C67C4E] transition-colors"
                    >
                        Admin
                    </a>
                </div>
            </div>
        </footer>
    );
}
